import { defineMessages } from 'react-intl';

export default defineMessages({
    tenant: {
        id: '_.residential_options.tenant',
        defaultMessage: 'Tenant'
    },
    owner_with_mortgage: {
        id: '_.residential_options.owner_with_mortgage',
        defaultMessage: 'Owner occupier (with mortgage)'
    },
    owner_no_mortgage: {
        id: '_.residential_options.owner_no_mortgage',
        defaultMessage: 'Owner occupier (no mortgage)'
    },
    rent_free: {
        id: '_.residential_options.rent_free',
        defaultMessage: 'Living rent free (e.g. with parents)'
    }
});
